import { Link } from "react-router-dom";
import SortableTable from "../../App/Components/Table/SortableTable";
import { IGroupMessageView } from "../../App/Typings/MessageText";
import { ITablePagination } from "../../App/Typings/SortableGroupTable.d ";
import { ITableColumn } from "../../App/Typings/TableColumn";
import { ScheduledActionButtons } from "./ScheduledActionButtons";
import { Button } from "@mui/material";
import dayjs from "dayjs";
import { useUserProfileStore } from "../../App/State/Stores/UserProfileStore";

const paginationOptions: ITablePagination = {
  rowsPerPage: [10, 15, 25],
  enabled: true,
};

export function MessageTable({
  id,
  loading,
  columns,
  tableData = [],
  isEditingGroup,
  deleteSelectedScheduledMessages = () => {
    return;
  },
  showActions,
  disableDeleteButton = false,
}: {
  id: string;
  columns: ITableColumn[];
  loading: boolean;
  tableData: IGroupMessageView[];
  isEditingGroup: boolean;
  deleteSelectedScheduledMessages?: (msg: IGroupMessageView) => void;
  showActions: boolean;
  disableDeleteButton?: boolean;
}) {
  const { getUserAdjustedDate } = useUserProfileStore();

  const tblData = tableData.map((msg: IGroupMessageView) => {
    if (showActions && deleteSelectedScheduledMessages) {
      return {
        ...msg,
        actions: (
          <ScheduledActionButtons
            message={msg}
            deleteSelectedScheduledMessages={deleteSelectedScheduledMessages}
            disabled={disableDeleteButton}
          />
        ),
      };
    } else {
      return msg;
    }
  });

  return (
    <SortableTable
      name={id}
      columns={columns}
      isEditingGroup={isEditingGroup}
      columnEditEnabled={false}
      loading={loading}
      tableData={tblData}
      selected={false}
      pagination={paginationOptions}
      emptyMessage="No records available."
      renderCustomCell={(row, column) => {
        const value = row[column.propName];

        if (column.propName === "recipient") {
          const id = row["recipientId"];
          return (
            <Button component={Link} target="_blank" to={`/candidates/${id}`}>
              {value}
            </Button>
          );
        } else if (
          (column.propName.toLowerCase().includes("date") ||
            column.propName.toLowerCase().includes("time")) &&
          dayjs(value).isValid()
        ) {
          return getUserAdjustedDate(value).format("MM/DD/YYYY h:mm A");
        }

        return value;
      }}
    />
  );
}
